export const WHATSAPP_URL =
  "https://wa.me/558791739334?text=Olá!%20Quero%20saber%20mais%20sobre%20o%20Verdana";

// Vídeos no YouTube. Formato do embed: https://www.youtube.com/embed/<ID>
// Parâmetros para o player mais limpo possível:
//   rel=0             → relacionados restritos ao mesmo canal (não há como remover 100%)
//   modestbranding=1  → esconde o logo do YouTube nos controles
//   playsinline=1     → toca dentro do modal no mobile, sem forçar fullscreen
//   iv_load_policy=3  → esconde anotações
// Dica: marque os vídeos como "Não listado" no YouTube para não aparecerem em buscas.
// TODO: substituir <ID> pelos IDs reais dos vídeos.
const YT_PARAMS = "rel=0&modestbranding=1&playsinline=1&iv_load_policy=3&color=white";
export const DEMO_VIDEO_SELLER = `https://www.youtube.com/embed/-y_DR5eJjeE?${YT_PARAMS}`;
export const DEMO_VIDEO_SERVICE = `https://www.youtube.com/embed/9OHuijfUYQ0?${YT_PARAMS}`;
